
    import './styles.scoped.css';
    export default {
  "handle": "awsui_handle_sdha6_1s3u7_5",
  "handle-disabled": "awsui_handle-disabled_sdha6_1s3u7_15"
};
  